import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { costingTabInfo } from 'features/costing/utils';

import { clearCosting, setActiveTabInfo } from '@store/actions/CostingAction';
import { clearGlobalFilter } from '@store/actions/FilterAction';

const ParentTabsForAdminRole = () => {
	const activeTabInfo = useSelector((store) => store.costingStore.activeTabInfo);
	const dispatch = useDispatch();

	const handleTabClick = (tabKey) => {
		dispatch(clearCosting());
		dispatch(setActiveTabInfo(costingTabInfo[tabKey]));
		dispatch(clearGlobalFilter());
	};

	return (
		<div>
			<ul>
				<li
					className={`${
						['BUYER_DESIGN_PENDING', 'BUYER_DESIGN_COMPLETED', 'BUYER_DESIGN_ARCHIVE'].includes(
							activeTabInfo?.activeTabName
						)
							? 'active'
							: ''
					}`}
					onClick={() => handleTabClick('BUYER_DESIGN_PENDING')}
				>
					Buyer Design
				</li>
				<li
					className={`${
						[
							'DESIGN_STUDIO_PENDING',
							'DESIGN_STUDIO_IN_REVIEW',
							'DESIGN_STUDIO_COMPLETED'
						].includes(activeTabInfo?.activeTabName)
							? 'active'
							: ''
					}`}
					onClick={() => handleTabClick('DESIGN_STUDIO_PENDING')}
				>
					Design Studio
				</li>
			</ul>
		</div>
	);
};

export default ParentTabsForAdminRole;
